import React from "react";
import "../../src/css/policy.css";
import LocationSlider from "./LocationSlider";

const Security = () => {
  return (
    <>
      <div className="main-policy">
        <section className="policy-header">
          <h1>Security Policy</h1>
          <p className="last-updated">
            LaunchEStore Commitment to Data Integrity
          </p>
        </section>

        <section className="policy-container">
          <p>
            At LaunchEStore, we prioritize the technical security of our platform
            to ensure your business operations remain uninterrupted and private.
          </p>

          <h2>A. Infrastructure Security</h2>
          <ul>
            <li>
              <strong>Cloud Protection:</strong> All data is hosted in
              high-security, professional cloud datacenters with 24/7
              monitoring.
            </li>
            <li>
              <strong>Network Isolation:</strong> Business and customer databases
              are stored on a private network layer and are not available or
              searchable on the public internet.
            </li>
            <li>
              <strong>Encryption:</strong> We use SSL/TLS encryption for all data
              transmitted between your browser and our servers.
            </li>
          </ul>

          <h2>B. Payment Security</h2>
          <ul>
            <li>
              <strong>No Storage of Card Data:</strong> LaunchEStore provides a
              secure bridge to your payment gateway (e.g., Stripe, Razorpay). We
              do not store sensitive credit card or banking information on our
              local servers.
            </li>
            <li>
              <strong>Secure API Integration:</strong> Connections to payment
              providers are handled via secure, encrypted API tokens.
            </li>
          </ul>

          <h2>C. Data Access Control</h2>
          <ul>
            <li>
              <strong>Restricted Access:</strong> Internal staff have no
              authorization to view private business data such as supplier lists
              or sales invoices unless explicitly requested by you for technical
              support.
            </li>
            <li>
              <strong>Regular Backups:</strong> Automated backups are performed
              regularly to prevent data loss in the event of hardware failure.
            </li>
          </ul>

          <h2>D. Reporting Security Issues</h2>
          <p>
            If you believe you have discovered a security vulnerability on the
            LaunchEStore platform, please report it immediately to our security
            team at{" "}
            <a href="mailto:support@launchestore.com">
              support@launchestore.com
            </a>
            .
          </p>
        </section>
      </div>

      <LocationSlider />
    </>
  );
};

export default Security;
